'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoFileSymlinkDirectory = function GoFileSymlinkDirectory(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 7.5h-13.7c-0.7 0-1.3-0.6-1.3-1.2v-1.3s-1.2-2.5-2.5-2.5h-12.5c-1.2 0-2.5 1.3-2.5 2.5v27.5h35v-22.5s-1.2-2.5-2.5-2.5z m-30-1.2c0-0.7 0.6-1.3 1.3-1.3h10c0.5 0 1.2 0.6 1.2 1.3v1.2h-12.5v-1.2z m15 21.2v-5c-4.9 0-8.7 2.2-10 7.5 0-8.2 4.2-12.5 10-12.5v-5l10 7.5-10 7.5z' })
        )
    );
};

exports.default = GoFileSymlinkDirectory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/file-symlink-directory.js
// module id = 1679
// module chunks = 0